import React, { useEffect, useState } from 'react';
import LcLoading from '../../../../components/Generic/LcLoading';
import { schedulesModel } from '../../../../services/cmsPremier/cmsPremierModel';
import { CmsPremierService } from '../../../../services/cmsPremier/cmsPremierService';
import { TbSettingsAutomation } from "react-icons/tb";
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import LcNoData from '../../../../components/Generic/LcNoData';



interface NextScheduleAutomationProps {
    isHome?: boolean;
}

const NextScheduleAutomation: React.FC<NextScheduleAutomationProps> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const CmsService = new CmsPremierService(props);
    const [loading, setLoading] = useState<boolean>(false);

    const [nextSchedule, setNextSchedule] = useState<schedulesModel>()
    const [nextAutomation, setNextAutomation] = useState<string>()
    const [dateSchudule, setDateSchedule] = useState<string>('')

    const getNextSchedule = async () => {
        try {

            setLoading(true)
            const response = await CmsService.getSchedulesData();
            let schedule = FindNextSchedule(response);
            console.log(JSON.parse(schedule.resource.data))
            if (schedule) {
                setNextSchedule(schedule.resource);
                setNextAutomation(schedule["Automation"]);
                setDateSchedule(schedule.date)
            }
            setLoading(false)
        } catch (error) {
            console.error('Error:', error);
            setLoading(false)
        }
    }

    useEffect(() => { getNextSchedule() }, [user.ClientGroupSelected, user.refreshFlag])

    function FindNextSchedule(arrayDeHorarios: schedulesModel[]) {
        // Obter a data e hora atual
        const agora = new Date();

        // Função para converter uma string de hora no formato "HH:mm:ss" em um objeto Date
        function parseHora(horaStr: string): Date {
            const [horas, minutos, segundos] = horaStr.split(':').map(Number);
            const data = new Date();
            data.setHours(horas);
            data.setMinutes(minutos);
            data.setSeconds(segundos);
            return data;
        }

        // Função para verificar se um dia da semana está agendado
        function isDiaAgendado(diaAgendado: string, diasDaSemana: string): boolean {
            const diasAgendados = diasDaSemana.split('-');
            return diasAgendados.includes(diaAgendado);
        }
        const diasDaSemanaPtBr = {
            SUN: "Domingo",
            MON: "Segunda",
            TUE: "Terça",
            WED: "Quarta",
            THU: "Quinta",
            FRI: "Sexta",
            SAT: "Sábado"
        };

        // Inicializa a variável para armazenar o objeto com o horário mais próximo
        let objetoMaisProximo: any | null = null;
        let diffMin = Infinity;
        const diaAtual = agora.toLocaleString('en-US', { weekday: 'short' }).toUpperCase().substr(0, 3);

        for (const objeto of arrayDeHorarios) {
            const horaAgendada = parseHora(objeto.hourScheduled);

            // Verifique se o dia da semana atual está agendado
            if (isDiaAgendado(diaAtual, objeto.weekDaysScheduled)) {
                if (horaAgendada > agora) {
                    const diff = horaAgendada.getTime() - agora.getTime();
                    if (diff < diffMin) {
                        diffMin = diff;
                        objetoMaisProximo = objeto;
                    }
                }
            }
        }
        if (objetoMaisProximo) {
            const diaAgendado = diasDaSemanaPtBr[diaAtual];
            const horarioAgendado = objetoMaisProximo.hourScheduled;
            const formato = `${diaAgendado} - ${horarioAgendado}`;
            return { resource: objetoMaisProximo, date: formato };
        } else {
            return { resource: objetoMaisProximo, date: '' };
        }
    }

    const handleStartStorage = () => {
        //ToDo
    }

    return (
        <LcLoading loading={loading}>
            {
                (nextSchedule && dateSchudule) ?
                    <div className='card-big-number colorfull'>
                        <div className={props.isHome ? '' : 'content'}>
                            {!props.isHome && <TbSettingsAutomation className='big-numbers-icons' size={'20rem'} />}
                            {props.isHome && <div className='title-schedule'>Próximo agendamento</div>}
                            <div style={{ color: 'white', display: 'flex', flexDirection: 'column', alignItems: props.isHome ? 'flex-start' : 'flex-end' }} className='subtitle-dash ellipsis' >
                                
                                <span title="Nome da automação" className={props.isHome ? 'automation-name-home' : 'automation-name'}>{JSON.parse(nextSchedule.data).Automation}</span>
                                {/*{!props.isHome && nextSchedule["lastRun"] && nextSchedule["lastRun"].includes("Error") &&*/}
                                {/*    <span style={{ textAlignLast: 'center', minWidth: '100%', margin: '.2rem 0rem', color: '#FF4455', backgroundColor: '#FFFFFF', borderRadius: '.2rem', border: 'none', padding: '.3rem', fontSize: '.7rem' }}>*/}
                                {/*        {nextSchedule["lastRun"]}*/}
                                {/*    </span>*/}
                                {/*}*/}
                                <span title="Recurso envolvido" style={{ color: props.isHome ? '#63BDC7' : '#fff', fontSize: '.7rem' }}>{JSON.parse(nextSchedule.data).ResourceId}</span>
                                <span title="Próxima execução" style={{ color: props.isHome ? 'var(--text-light)' : '#fff', fontSize: '.7rem', }}>{dateSchudule}</span>
                            </div>
                        </div>
                    </div>
                    :
                    <div style={{ color: props.isHome ? 'var(--text-default)' : '#fff', fontSize: '.7rem' }}>Sem dados</div>
            }
        </LcLoading>
    )
}

export default NextScheduleAutomation;